import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const ConfigContext = createContext(null);

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    api.get("/config").then((r) => setConfig(r.data)).catch(() => {});
  }, []);

  // SEO + analytics injection
  useEffect(() => {
    if (!config) return;
    document.title = "Hollanda Emlak — Hollanda'da Ücretsiz Kiralama | Ev Sahibi & Kiracı";
    const setMeta = (name, content, attr = "name") => {
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta("description", "Hollanda Emlak evinizi doğrudan kiralar, kiracınızı bulur. Ev sahipleri için %100 ücretsiz. Kiracılar ortalama 2 hafta içinde ev.");
    setMeta("og:title", "Hollanda Emlak — Hollanda'da Ücretsiz Kiralama", "property");
    setMeta("og:description", "Ev sahiplerinden 0€. Kiracılar ortalama 2 hafta içinde ev. Tüm Hollanda'da Türkçe destek.", "property");
    setMeta("og:type", "website", "property");

    if (config.meta_pixel_id && !window.fbq) {
      /* eslint-disable */
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
        if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
        t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
      })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
      /* eslint-enable */
      window.fbq("init", config.meta_pixel_id);
      window.fbq("track", "PageView");
    }
    if (config.ga4_id && !window.gtag) {
      const s = document.createElement("script");
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${config.ga4_id}`;
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () { window.dataLayer.push(arguments); };
      window.gtag("js", new Date());
      window.gtag("config", config.ga4_id);
    }
  }, [config]);

  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
}

export function useConfig() {
  return useContext(ConfigContext);
}
